import { render, staticRenderFns } from "./Wrapper-ext.vue?vue&type=template&id=3a81ac42&lang=pug&"
import script from "./Wrapper-ext.vue?vue&type=script&lang=js&"
export * from "./Wrapper-ext.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports